import {
  getCommonAssetByCat
} from '@ps/api/common/asset'
import _ from 'lodash'
import store from '@ps/store'
import { filter } from '@ps/bridge/qc/node/utils'
import { resetAndStopAnimation } from '@ps/bridge/qc/node'
import { rad2deg } from '@com/utils/unit-converters/angle'
import gameIframe from '@ps/bridge/iframe/iframe'
import { updatePositionTween } from '@ps/workbench/animation'

const animation = {
  namespaced: true,

  state: {
    builtinDialog: {
      visible: false
    },
    builtinList: [],
    tweenPositionAreaActived: false,
    hasAnimationGhost: false,
    activeAnimationUUID: ''
  },

  mutations: {
    updateAnimationBuiltin(state, { visible }) {
      state.builtinDialog.visible = visible
    },
    updateAnimationGhost(state, value) {
      state.hasAnimationGhost = value
    },
    updateActiveAnimationUUID(state, value) {
      state.activeAnimationUUID = value
    },
    updateBuiltinList(state, { list }) {
      state.builtinList = list
    },
    updateTweenPositionAreaActived(state, value) {
      state.tweenPositionAreaActived = value
    }
  },

  actions: {
    showAnimationBuiltin({ commit, state }, { visible }) {
      commit('updateAnimationBuiltin', { visible })
    },
    async getAnimationBuiltin({ commit, state }) {
      const res = await getCommonAssetByCat({
        type: 18,
        limit: 100
      })
      commit('updateBuiltinList', {
        list: _.get(res, 'data') || []
      })
    },

    // 添加动画结束位置虚拟节点
    addGhost({ commit, state }, { node, animation }) {
      let data = {}
      const sourceNode = node

      const getAnimationProp = (animation) => {
        const name = animation.animationClassName || animation.class || ''
        if (name.indexOf('TweenPosition') > -1) {
          const tweens = sourceNode.scripts.filter(item => (item.animationClassName || item.class).indexOf('TweenPosition') > -1)
          const currentAnimation = tweens.find(item => item.uuid === animation.uuid)
          return {
            x: currentAnimation.to.x,
            y: currentAnimation.to.y
          }
        } else if (name.indexOf('TweenRotation') > -1) {
          return {
            rotation: animation.to
          }
        } else if (name.indexOf('TweenScale') > -1) {
          return {
            scaleX: animation.to.x,
            scaleY: animation.to.y
          }
        } else if (name.indexOf('TweenAlpha') > -1) {
          return {
            alpha: animation.to
          }
        }
        return {}
      }

      if (animation.builtinId) {
        node.scripts.filter(script => script.builtinId === animation.builtinId).forEach(item => {
          data = {
            ...data,
            ...getAnimationProp(item)
          }
        })
      } else {
        data = {
          ...data,
          ...getAnimationProp(animation)
        }
      }

      store.dispatch('workspace/stage/addVirtualNodeGhost', {
        x: sourceNode.x,
        y: sourceNode.y,
        ..._.pick(sourceNode, ['width', 'height', 'rotation', 'scaleX', 'scaleY', 'alpha']),
        rotation: rad2deg(sourceNode.rotation),
        ...data,
        sourceNode: sourceNode
      })
      commit('updateAnimationGhost', true)
    },

    // 根据激活节点、当前激活动画id，尝试更新虚拟节点样式
    destroyAndAddGhost({ commit, state, rootState }) {
      const activeAnimationUUID = rootState.workspace.animation.activeAnimationUUID
      const curAnimation = rootState.workspace.game.activeNode.scripts.find(item => {
        const name = item.class || item.animationClassName
        return (item.builtinId || item.uuid) === activeAnimationUUID && name === 'qc.TweenPosition'
      })
      if (activeAnimationUUID && curAnimation) {
        store.dispatch('workspace/stage/destroyVirtualNodeGhost')
        setTimeout(() => {
          store.dispatch('workspace/animation/addGhost', {
            node: rootState.workspace.game.activeNode,
            animation: curAnimation
          })
        }, 50)
      }
    },

    updateCurrentAnimation({ commit, state, rootState }, data) {
      const activeAnimationUUID = rootState.workspace.animation.activeAnimationUUID
      const positionAnimation = rootState.workspace.game.activeNode.scripts.find(item => {
        const name = item.class || item.animationClassName
        return (item.builtinId || item.uuid) === activeAnimationUUID && name === 'qc.TweenPosition'
      })
      store.dispatch('workspace/game/setAnimation', {
        node: rootState.workspace.game.activeNode,
        animations: [{
          uuid: positionAnimation.uuid,
          to: new gameIframe.qc.Point(data.x, data.y),
          from: new gameIframe.qc.Point(positionAnimation.from.x, positionAnimation.from.y)
        }]
      })
      updatePositionTween(rootState.workspace.game.activeNode)
    },

    resetCurrentSceneAnimation() {
      const scene =
        store.state.workspace.sceneManager.currentSceneNode
      if (scene) {
        const nodeList = filter(scene, item =>
          item.getScript('qc.Tween')
        )
        nodeList.forEach(node => resetAndStopAnimation(node))
      }
    }
  }
}

export default animation
